import { AlertTriangle } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"

const actionClassName =
  "py-2 px-4 bg-background border border-foreground text-foreground rounded-full hover:bg-muted hover:text-muted-foreground transition text-sm font-medium"

export type PageLoadErrorProps = {
  title: string
  subtitle: string
  detail?: string | null
  reloadLabel?: string
  backLabel?: string
  onReload?: () => void
  onBack?: () => void
  layout?: "fullscreen" | "embedded"
  className?: string
}

export function PageLoadError({
  title,
  subtitle,
  detail,
  reloadLabel,
  backLabel,
  onReload,
  onBack,
  layout = "embedded",
  className,
}: PageLoadErrorProps) {
  const showReload = Boolean(onReload && reloadLabel)
  const showBack = Boolean(onBack && backLabel)

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center bg-background px-6",
        layout === "fullscreen" ? "min-h-screen" : "min-h-full flex-1 py-12",
        className,
      )}
      role="alert"
    >
      <AlertTriangle className="mb-4 h-12 w-12 text-muted-foreground" aria-hidden="true" />
      <h1 className={cn("font-bold text-foreground", layout === "fullscreen" ? "text-3xl" : "text-2xl")}>
        {title}
      </h1>
      <p className={cn("mt-2 text-muted-foreground", layout === "fullscreen" ? "mb-6 text-lg" : "mb-4 text-sm")}>
        {subtitle}
      </p>
      {detail ? <p className="mb-4 max-w-md text-xs text-muted-foreground/80">{detail}</p> : null}
      {(showReload || showBack) && (
        <div className="flex flex-wrap items-center justify-center gap-3">
          {showReload ? (
            <Button type="button" className={actionClassName} variant="ghost" onClick={onReload}>
              {reloadLabel}
            </Button>
          ) : null}
          {showBack ? (
            <Button type="button" className={actionClassName} variant="ghost" onClick={onBack}>
              {backLabel}
            </Button>
          ) : null}
        </div>
      )}
    </div>
  )
}
